import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { useLocation } from 'react-router-dom';

export default function Layout() {
  const location = useLocation();

  const getPageName = () => {
    switch (location.pathname) {
      case '/': return '首页';
      case '/categories': return '分类';
      case '/articles': return '文章';
      case '/about': return '关于我们';
      default: return '';
    }
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{ name: `jinman - ${getPageName()}`, description: 'jinman品牌核心介绍，全面展示jinman的核心优势、产品服务与用户口碑。' }} />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
}